import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SidebarStateService {
  private menuMinimizedSubject = new Subject<boolean>();

  get menuMinimizedChanges$(): Observable<boolean> {
    return this.menuMinimizedSubject.asObservable();
  }

  notifyMenuMinimizedChange(isMinimized: boolean): void {
    this.menuMinimizedSubject.next(isMinimized);
  }
}
